"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryEventVariantJSONModel = void 0;
const EventJSONModel_1 = require("src/hello_assets/src/components/model/common/event/EventJSONModel");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
class QueryEventVariantJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetValue();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                switch (serializedState.type) {
                    case "event":
                        this.setValue({
                            type: "event",
                            event: new EventJSONModel_1.EventJSONModel(serializedState.event)
                        });
                        break;
                    case "newUser":
                    case "session":
                    case "anyEvent": {
                        this.setValue(serializedState);
                        break;
                    }
                }
            }
        };
        this.serialize = () => {
            const value = this.getValue();
            if (value) {
                switch (value.type) {
                    case "event":
                        return {
                            type: "event",
                            event: value.event.serialize()
                        };
                    case "newUser":
                    case "session":
                    case "anyEvent":
                        return value;
                }
            }
            return undefined;
        };
        ////////////////////////////////////////////////
        // Value
        ////////////////////////////////////////////////
        this.getValue = () => this.value;
        this.setValue = (value) => {
            if (!this.isValueValid(value)) {
                this.resetValue();
            }
            else {
                this.value = value;
            }
        };
        this.setValueAsEventJSONModel = (eventJSONModel) => {
            this.setValue({ type: "event", event: eventJSONModel });
        };
        this.setValueAsQueryEventVariant = (queryEventVariant) => {
            this.setValue(CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.queryEventVariantToQueryEventVariantComposite(queryEventVariant));
        };
        this.resetValue = () => {
            this.value = undefined;
        };
        this.getValueAsQueryEventVariant = () => {
            return CommonTypesConversions_1.CommonTypesConversions.queryEventVariant.queryEventVariantCompositeToQueryEventVariant(this.getValue());
        };
        ////////////////////////////////////////////////
        // Validation
        ////////////////////////////////////////////////
        this.isValueValid = (value) => {
            if (value) {
                switch (value.type) {
                    case "newUser":
                    case "event":
                    case "session":
                    case "anyEvent":
                        return true;
                }
            }
            return false;
        };
        this.isFilled = () => {
            const value = this.value;
            if (value) {
                switch (value.type) {
                    case "event":
                        return value.event.isFilled();
                    case "newUser":
                    case "session":
                    case "anyEvent":
                        return true;
                }
            }
            return false;
        };
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.QueryEventVariantJSONModel = QueryEventVariantJSONModel;
